import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointsNameCell } from './charge-points-name.cell';
import { ChargePointsNameHeader } from './charge-points-name.header';

export const ChargePointsNameColumn: IdentifiedColumnDef<
  GatewayChargePointInMaintenanceModel,
  GatewayChargePointInMaintenanceModel['name']
> = {
  enableSorting: false,
  header: ChargePointsNameHeader,
  cell: ChargePointsNameCell,
};
